import { deviceApi } from '@/redux/api/endpoints/device';
import { DispatchOptimisticPatchHandler } from '@/redux/types/dispatch-optimistic-patch-handler';
import { removeItemRecipe } from '@/redux/utils/remove-item-recipe';
import { DeleteDeviceQueryArg } from '../types/query-arg';

export const dispatchOptimisticPatchDeleteDevice: DispatchOptimisticPatchHandler<
  DeleteDeviceQueryArg
> = (queryArg, { dispatch }) => {
  const patch = dispatch(
    deviceApi.util.updateQueryData(
      'getUnassociatedDevices',
      {},
      removeItemRecipe('id', queryArg.id),
    ),
  );

  return { patch };
};
